module.exports = __webpack_public_path__ + "69a1c2e6042a881a537443716e668232.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-panel-1080.webp
// module id = 468
// module chunks = 0